import type { LocalDatabasePriceSet } from "../../../_Generated/Sync.gen";
import type { BasePriceSetRepository } from "../../_Bases/BasePriceSetRepository";
import type { InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBPriceSetsRepository extends BaseIndexedDBRepository<
    LocalDatabasePriceSet
> implements BasePriceSetRepository {
    public readonly source: InternalIndexedDBDatabase["priceSets"];
    protected readonly dataTypeName = "Price Set";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.priceSets;
    }
}
